export const canvasSize = 30000;
export const canvasGap = 40; // offset to ensure adstates do not butt against corner of page
export const rulerThickness = 20;
export const canvasPanelTop = 115;
export const canvasOffset = [0, 110];
export const fontSize = 14;
export const adStateLabelHeight = 40;
export const collapsedAnimationPanelHeight = 65;
export const menuBarsHeight = 60;
export const viewportDashWidth = {
  standard: 10,
  min: 5,
  max: 12,
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/constants/viewportLayout.js